import { html } from 'fxjs/es';

export const fn = ({ content }) => html`<div class="pd-modal__content">${content}</div>`;
